import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getFormValues, isValid, reset, change } from 'redux-form';
import { List, Map, fromJS } from 'immutable';

import * as common from 'libs/commonFunc';
import * as validFunc from 'libs/validation';

import { ExamSummary } from 'components';

import * as examSummaryActions from 'modules/examSummary';
import * as examListActions from 'modules/examList';
import * as examActions from 'modules/exam';
import * as currentStatusActions from 'modules/currentStatus';

let SEARCH_VALUE = '';
class CtExamSummary extends Component {
  constructor(props) {
    super(props);

    const { examParam } = this.props;
    const filterData = examParam.get('filter').toJS();

    this.state = {
      filterState: 0,
      isEditExamData: { examNo: 0 },
      isLoading: false,
      isClicked: false
    };

    this.onInfectionFilter = this.onInfectionFilter.bind(this);
    this.onSelectExamSummary = this.onSelectExamSummary.bind(this);
  }

  componentWillMount() {
    const { ExamSummaryActions } = this.props;
    ExamSummaryActions.changeExamSummary({ name: 'isMounting', value: true });
  }

  componentDidMount() {
    this.onGetExamSummary();
    // window.addEventListener('scroll', this.onScroll);
    // this.onGetExamSummary(true);
  }

  componentDidUpdate(prevProps, prevState) {
    const { needReload, examParam, page, listPage, startExamResult } = this.props;

    if (
      (needReload && !this.state.isLoading) ||
      // 필터
      examParam !== prevProps.examParam ||
      // 훈련 실시 후
      startExamResult !== prevProps.startExamResult
    ) {
      // this.onGetExamSummary(true);
      this.onGetExamSummary();
    } 
    // else if (page < listPage && listPage !== prevProps.listPage) {
    //   this.onGetExamSummary();
    // }
  }

  // 스크롤 움직일 시 발생하는 이벤트
  // onScroll = () => {
  //   if (!this.summaryScroll) return;

  //   if (this.summaryScroll.scrollHeight === this.summaryScroll.scrollTop + this.summaryScroll.offsetHeight) {
  //     this.onGetExamSummary();
  //   }
  // }

  onGetExamSummary = async () => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const { ExamSummaryActions, examParam, page, totalPage, listPage } = this.props;
        const param = {
          filter: JSON.stringify(examParam.get('filter')),
          // sort: JSON.stringify(examParam.get('sort')),
          // offset: examParam.get('limit') * page,
          // offset: 0,
          // limit: examParam.get('limit')
        };

        await ExamSummaryActions.getExamSummary(param);
        // if (refresh) {
        //   param['refresh'] = true;
        //   await ExamSummaryActions.getExamSummary(param);
        //   if (this.summaryScroll) {
        //     this.summaryScroll.scrollTop = 0;
        //   }
        // } else if (totalPage > page) {
        //   // 훈련 개수가 훈련 요약 개수보다 많을 시 무한스크롤 처리
        //   const pageCnt = listPage - 1 > page ? listPage - 1 : page;
        //   param['offset'] = examParam.get('limit') * pageCnt;
        //   await ExamSummaryActions.getExamSummary(param);
        // }
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 훈련 요약 선택하기
  onSelectExamSummary = (examNo, examType) => {
    const { CurrentStatusActions, ExamListActions } = this.props;
    const { path } = this.props;

    // 선택 훈련이 피싱이고 current path가 감염PC,감염파일일때
    if (examType === 4) {
      if (path.get('current') === '/main/exam/infectionpc' || path.get('current') === '/main/exam/leakfile') {
        this.props.history.push('/main/exam/pi');
      }
    }

    const { ExamSummaryActions } = this.props;
    ExamSummaryActions.getExamSummary();

    if (examNo === 'all') {
      // 필터 초기화

      ExamSummaryActions.changeParam({
        name: 'filter',
        value: Map({})
      });
      ExamListActions.changeExamListParam({
        name: 'filter',
        value: Map({})
      });
    }

    CurrentStatusActions.changeExamSummary({ name: 'selected', value: examNo });
    CurrentStatusActions.changeExamSummary({
      name: 'isExamType',
      value: examType
    });
    ExamListActions.changeExamListParam({
      name: 'filter',
      value: Map({})
    });
  };

  // (발송, 열람, 감염) 상세 필터 걸어서 이동
  onSelectEachInfo = (examNo, type) => {
    const { CurrentStatusActions, ExamListActions } = this.props;

    const filter = {};
    filter[type] = 1;
    CurrentStatusActions.changeExamSummary({ name: 'selected', value: examNo });
    ExamListActions.changeExamListParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 훈련 요약 열기/닫기
  onToggleExamSummary = examNo => {
    const { CurrentStatusActions, examSummaryOrdering } = this.props;

    if (typeof examNo !== 'undefined') {
      CurrentStatusActions.toggleExamSummary({ examNo });
    } else {
      //
      CurrentStatusActions.toggleAllExamSummary({ examNoArray: examSummaryOrdering });
    }
  };

  // 훈련 즉시 실행/종료
  onExamNow = async (examNo, nowType) => {
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { ExamSummaryActions, examSummaryByExamNo } = this.props;

      const resultMessage =
        "'" +
        examSummaryByExamNo.get(String(examNo)).get('examName') +
        "' " +
        (nowType === 'isStartNow'
          ? defineMessages(formatMessage({ id: 'CtExamSummary_2', defaultMessage: '훈련 즉시 실행' }))
          : defineMessages(formatMessage({ id: 'CtExamSummary_3', defaultMessage: '훈련 즉시 종료' })));
      const params = { examNo: examNo };
      params[nowType] = 1;

      await ExamSummaryActions.putExam(params);
      this.onToggleModal('');
      this.onToggleSnackbar(resultMessage);
    } catch (e) {
      console.log(e);
    }
  };

  // 메일 발송 정지, 재시작 1: 정지 0: 재시작
  onExamPause = async (examNo, isSuspend) => {
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { ExamSummaryActions, examSummaryByExamNo } = this.props;

      let resultMessage = "'" + examSummaryByExamNo.get(String(examNo)).get('examName') + "' ";
      if (isSuspend === 1) {
        resultMessage += defineMessages(
          formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
        );
      } else {
        resultMessage += defineMessages(
          formatMessage({ id: 'ExamSummaryItem_17', defaultMessage: '메일 발송 재시작' })
        );
      }

      const params = { examNo, isSuspend };
      await ExamSummaryActions.examPause(params);
      this.onToggleSnackbar(resultMessage);
    } catch (e) {
      console.log(e);
    }
  };

  // 필터(감염이 있는 훈련, 완료된 훈련, 진행중인 훈련)
  onInfectionFilter = (filterName, filterState) => {
    const { examParam, ExamSummaryActions, CurrentStatusActions } = this.props;
    // 선택 초기화
    // this.onSelectExamSummary('all');

    //CurrentStatusActions.changeExamSummary({ name: 'isInfection', value: !isInfection });

    const filter = examParam.get('filter').toJS();
    const selectedFilter = { ...filter };

    if (typeof selectedFilter[filterName] === 'undefined') {
      filter[filterName] = 1;
    } else {
      delete filter[filterName];
    }

    CurrentStatusActions.changeExamSummary({ name: 'selected', value: 'all' });
    ExamSummaryActions.changeParam({
      name: 'filter',
      //value: !isInfection ? fromJS({ ...filter, infection: 1 }) : fromJS(filter)
      value: fromJS(filter)
    });
  };

  // 태그 검색 모드
  onSearchActive = () => {
    const { isSearchActive, CurrentStatusActions, examParam } = this.props;
    //CurrentStatusActions.changeExamSummary({ name: 'isSearchActive', value: !isSearchActive });
    CurrentStatusActions.changeExamSummary({ name: 'isSearchActive', value: true });

    // 검색 된 상태일 경우 검색어 입력
    CurrentStatusActions.changeExamSummary({ name: 'searchText', value: examParam.getIn(['filter', 'examName']) });
  };

  // summary 검색 끄기
  onSearchBlur = () => {
    setTimeout(() => {
      let searchValue = '';
      searchValue = SEARCH_VALUE;
      const { examParam, CurrentStatusActions } = this.props;

      if (searchValue !== examParam.getIn(['filter', 'examName'])) {
        if (this.myTextInput && this.myTextInput.value !== '') {
          if (examParam.getIn(['filter', 'examName'])) {
            this.myTextInput.value = examParam.getIn(['filter', 'examName']);
          } else {
            SEARCH_VALUE = '';
            this.myTextInput.value = '';
            CurrentStatusActions.changeExamSummary({ name: 'isSearchActive', value: false });
          }
        }
      } else {
        if (!searchValue) {
          CurrentStatusActions.changeExamSummary({ name: 'isSearchActive', value: false });
        }
      }
    }, 100);
  };

  // 태그 검색어 입력

  onKeyupSearch = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onSearch();
    }
  };

  // 검색 입력값 받아오기
  onChangeSearch = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  // 태그 검색 취소
  onClearSearch = () => {
    let searchValue = '';
    const { CurrentStatusActions } = this.props;
    SEARCH_VALUE = '';
    searchValue = SEARCH_VALUE;
    CurrentStatusActions.changeExamSummary({ name: 'searchText', value: searchValue });
    CurrentStatusActions.changeExamSummary({ name: 'isSearchActive', value: false });

    setTimeout(() => {
      this.onSearch();
    }, 100);

    if (this.myTextInput && this.myTextInput.value !== '') {
      this.myTextInput.value = '';
    }
  };

  // 검색
  onSearch = () => {
    let searchValue = '';
    const { CurrentStatusActions, ExamSummaryActions, examParam, searchText } = this.props;
    const filter = examParam.get('filter').toJS();
    delete filter['examName'];

    searchValue = SEARCH_VALUE;
    if (this.myTextInput && this.myTextInput.value !== '') {
      this.myTextInput.value = searchValue;
    }
    CurrentStatusActions.changeExamSummary({ name: 'searchText', value: searchValue });
    CurrentStatusActions.changeExamSummary({ name: 'selected', value: 'all' });
    ExamSummaryActions.changeParam({
      name: 'filter',
      value: !!searchValue ? fromJS({ ...filter, examName: searchValue }) : fromJS(filter)
    });
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formExamEdit');
    ReduxFormReset('formExamDelete');
    ReduxFormReset('formExamResend');

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 훈련 수정/삭제/재전송 모달
  onExamToggleModal = (examNo, modalType) => {
    const { examSummaryByExamNo } = this.props;
    this.setState({ isEditExamData: examSummaryByExamNo.get(String(examNo)) });

    this.onToggleModal(modalType);
  };

  // 훈련 수정
  onExamEdit = () => {
    this.setState({ isClicked: true });

    setTimeout(async () => {
      try {
        // 국제화 처리
        const { formatMessage } = this.props.intl;
        const {
          examSummaryByExamNo,
          ExamSummaryActions,
          formExamEdit,
          formExamEditIsValid,
          formExamEditStore
        } = this.props;

        if (!!formExamEdit && formExamEditIsValid) {
          let isEdit = false;
          const beforeData = examSummaryByExamNo.get(String(formExamEdit.examNo));
          const params = {
            examNo: formExamEdit.examNo
          };

          // 훈련명 수정
          // if (
          //   formExamEdit.examName !== beforeData.get('examName') &&
          //   // 훈련명 중복 체크
          //   !await validFunc.examNameValidate(formExamEdit.examName)
          // ) {
          if (formExamEdit.examName !== beforeData.get('examName')) {
            isEdit = true;
            params.examName = formExamEdit.examName;
          }

          // 훈련 시작 시간 수정
          if (
            typeof formExamEdit.examStartDate !== 'undefined' &&
            formExamEdit.examStartDate !== common.timeFormatFromUTCEpoch(beforeData.get('examStartEpoch'), 3)
          ) {
            isEdit = true;
            // 훈련 시작일을 현재로 수정할 경우
            if (common.epochFromDate(formExamEdit.examStartDate) < common.nowEpoch()) {
              params.examStartEpoch = common.nowEpoch();
            } else {
              params.examStartEpoch = common.epochFromDate(formExamEdit.examStartDate);
            }
          }

          // 훈련 종료 시간 수정
          if (
            typeof formExamEdit.examEndDate !== 'undefined' &&
            formExamEdit.examEndDate !== common.timeFormatFromUTCEpoch(beforeData.get('examEndEpoch'), 3)
          ) {
            // 훈련 종료일이 시작일 + 2일 보다 작을경우
            if (
              common.epochFromDate(formExamEdit.examEndDate) - common.epochFromDate(formExamEdit.examStartDate) <
              86400 * 2 + 10
            ) {
              isEdit = false;
              const { Dispatch } = this.props;
              Dispatch(change('formExamEdit', 'examEndDate', ''));
              window.markFieldValidate(formExamEditStore, 'formExamEdit');
            } else {
              isEdit = true;
              params.examEndEpoch = common.epochFromDate(formExamEdit.examEndDate);
            }
          }

          // 훈련 메일 나눔 발송
          if (Number(formExamEdit.sendReserveEnable) === 1) {
            if (formExamEdit.sendReservePeriod !== beforeData.get('sendReservePeriod')) {
              isEdit = true;
              params.sendReservePeriod = Number(formExamEdit.sendReservePeriod);
            }

            if (formExamEdit.sendReserveHour !== beforeData.get('sendReserveHour')) {
              isEdit = true;
              params.sendReserveStartHour = formExamEdit.sendReserveHour[0];
              params.sendReserveEndHour = formExamEdit.sendReserveHour[1];
            }
          } else {
            isEdit = true;
            params.sendReserveDelete = 1;
            // 수정시에 발송 예약 체크 해제시 메일 즉시 발송으로 변경됨
            // 아래의 param를 보내야 redux의 데이터가 update 됨(전송하는 param값을 바탕으로 데이터 업데이트함)
            params.sendReservePeriod = '';
            params.sendReserveStartHour = '';
            params.sendReserveEndHour = '';
          }

          if (isEdit) {
            await ExamSummaryActions.putExam(params);
            this.onToggleSnackbar(
              "'" +
              formExamEdit.examName +
              "' " +
              defineMessages(formatMessage({ id: 'CtExamSummary_4', defaultMessage: '훈련 수정' }))
            );
            this.onToggleModal('');
          } else {
            console.log('수정 사항 없음');
          }
        } else {
          window.markFieldValidate(formExamEditStore, 'formExamEdit');
        }

        this.setState({ isClicked: false });
      } catch (e) {
        console.log(e);
      }
    }, 100);
  };

  // 훈련 삭제
  onExamDelete = async () => {
    //
    this.setState({ isClicked: true });

    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const {
        selectedExamSummaryNo,
        ExamSummaryActions,
        formExamDelete,
        formExamDeleteIsValid,
        formExamDeleteStore
      } = this.props;

      if (formExamDeleteIsValid) {
        // 현재 선택된 훈련이 삭제될경우 전체훈련으로 선택해준다.
        if (formExamDelete.examNo === selectedExamSummaryNo) {
          this.onSelectExamSummary('all');
        }

        await ExamSummaryActions.deleteExam({ examNoArray: List([formExamDelete.examNo]) });
        this.onToggleSnackbar(
          "'" +
          formExamDelete.examName +
          "' " +
          defineMessages(formatMessage({ id: 'CtExamSummary_5', defaultMessage: '훈련 삭제' }))
        );
        this.onToggleModal('');
      } else {
        window.markFieldValidate(formExamDeleteStore, 'formExamDelete');
      }

      this.onGetExamSummary(true);
      this.setState({ isClicked: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 훈련 메일 재전송
  onExamResend = async (isModal) => {
    //
    this.setState({ isClicked: true });

    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { ExamSummaryActions, formExamResend, formExamResendIsValid, formExamResendStore } = this.props;

      if (formExamResendIsValid) {
        console.log(isModal)
        const params = {
          examNo: formExamResend.examNo,
          sendType: isModal
        };
        
        await ExamSummaryActions.putExamResend(params);
        this.onToggleSnackbar(
          "'" +
          formExamResend.examName +
          "' " +
          defineMessages(formatMessage({ id: 'CtExamSummary_8', defaultMessage: '훈련메일 재전송' }))
        );
        this.onToggleModal('');
      } else {
        window.markFieldValidate(formExamResendStore, 'formExamResend');
      }

      this.setState({ isClicked: false });
    } catch (e) {
      console.log(e);
    }
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  // scrollRef = ref => {
  //   this.summaryScroll = ref;
  // }

  render() {
    // 데이터
    const {
      currentPath,
      examSummaryOrdering,
      examSummaryByExamNo,
      isModal,
      isAllOpen,
      isOpen,
      isInfection,
      searchText,
      selectedExamSummaryNo,
      formExamEdit,
      examParam
    } = this.props;
    // function
    const {
      onSelectExamSummary,
      onToggleExamSummary,
      onInfectionFilter,
      onSelectEachInfo,
      onExamNow,
      onExamPause,
      onToggleModal,
      onExamToggleModal,
      onExamEdit,
      onExamDelete,
      onExamResend,
      searchTextRef
    } = this;
    // 검색
    const { isSearchActive } = this.props;
    const { onSearchActive, onSearchBlur, onSearch, onKeyupSearch, onClearSearch, onChangeSearch, scrollRef } = this;

    return (
      <ExamSummary
        currentPath={currentPath}
        examSummaryOrdering={examSummaryOrdering}
        examSummaryByExamNo={examSummaryByExamNo}
        // 버튼 클릭여부
        isClicked={this.state.isClicked}
        isLoading={this.state.isLoading}
        isModal={isModal}
        isAllOpen={isAllOpen}
        isOpen={isOpen}
        // scrollRef={scrollRef}
        // onScroll={this.onScroll}
        // 필터
        filter={examParam.get('filter').toJS()}
        // 수정/삭제할 훈련 번호
        isEditExamData={this.state.isEditExamData}
        selectedExamSummaryNo={selectedExamSummaryNo}
        onSelectExamSummary={onSelectExamSummary}
        onToggleExamSummary={onToggleExamSummary}
        onInfectionFilter={onInfectionFilter}
        onSelectEachInfo={onSelectEachInfo}
        onExamNow={onExamNow}
        onExamPause={onExamPause}
        onToggleModal={onToggleModal}
        onExamToggleModal={onExamToggleModal}
        onExamEdit={onExamEdit}
        onExamDelete={onExamDelete}
        onExamResend={onExamResend}
        formExamEdit={formExamEdit}
        // 훈련 검색
        searchProps={{
          searchText: searchText,
          isSearchActive: isSearchActive,
          onSearchActive: onSearchActive,
          onSearchBlur: onSearchBlur,
          onSearch: onSearch,
          onChangeSearch: onChangeSearch,
          onKeyupSearch: onKeyupSearch,
          onClearSearch: onClearSearch,
          searchTextRef: searchTextRef
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.examSummary.get('needReload'),
  examParam: state.examSummary.get('param'),
  path: state.currentStatus.get('path'),
  page: state.examSummary.get('page'),
  totalPage: state.examSummary.get('totalPage'),
  examSummaryOrdering: state.examSummary.get('examSummaryOrdering'),
  examSummaryByExamNo: state.examSummary.get('examSummaryByExamNo'),
  // listPage: state.examList.get('page'),
  isModal: state.currentStatus.get('isModal'),
  isSearchActive: state.currentStatus.getIn(['examSummary', 'isSearchActive']),
  isAllOpen: state.currentStatus.getIn(['examSummary', 'isAllOpen']),
  isOpen: state.currentStatus.getIn(['examSummary', 'isOpen']),
  isInfection: state.currentStatus.getIn(['examSummary', 'isInfection']),
  searchText: state.currentStatus.getIn(['examSummary', 'searchText']),
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected']),
  startExamResult: state.exam.get('startExamResult'),
  formExamEditStore: state.form['formExamEdit'],
  formExamDeleteStore: state.form['formExamDelete'],
  formExamResendStore: state.form['formExamResend'],
  formExamEdit: getFormValues('formExamEdit')(state),
  formExamDelete: getFormValues('formExamDelete')(state),
  formExamResend: getFormValues('formExamResend')(state),
  formExamEditIsValid: isValid('formExamEdit')(state),
  formExamDeleteIsValid: isValid('formExamDelete')(state),
  formExamResendIsValid: isValid('formExamResend')(state)
});

const mapDispatchToProps = dispatch => ({
  ExamSummaryActions: bindActionCreators(examSummaryActions, dispatch),
  ExamListActions: bindActionCreators(examListActions, dispatch),
  ExamActions: bindActionCreators(examActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch),
  Dispatch: dispatch
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamSummary)));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamSummary.js